import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Validators, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { AuthService } from '../../auth.service';
import { Usuario } from 'src/app/shared/model/security/usuario.model';
import swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'app-password',
    standalone: true,
    templateUrl: './password.component.html',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule
      ],
})
export class PasswordComponent implements OnInit {
    formGroupUsuario: FormGroup;
    usuarioObj: Usuario = new Usuario();
    confirmaPass:string;
    get formUsuar() { return this.formGroupUsuario.controls; }
    constructor(private formBuilder: FormBuilder, private authS: AuthService, private router: Router, private cdr: ChangeDetectorRef) { }
    ngOnInit() {
        this.formGroupUsuario = this.formBuilder.group({
            ctrlPasswd: ['', [Validators.required, Validators.minLength(1)]],
            ctrlNewPasswd: ['', [Validators.required, Validators.minLength(6)]],
            ctrlConfPasswd: ['', [Validators.required, Validators.minLength(6)]],
        }, {
            validator: this.validaPassword('ctrlNewPasswd', 'ctrlConfPasswd')
        });
        this.cdr.detectChanges();
    }
    validaPassword(controlPass, controlRepass) {
        return (formGroup: FormGroup) => {
            const control = formGroup.controls[controlPass];
            const matchingControl = formGroup.controls[controlRepass];

            if (matchingControl.errors && !matchingControl.errors.mustMatch) {
                return;
            }
            if (control.value !== matchingControl.value) {
                matchingControl.setErrors({ mustMatch: true });
            } else {
                matchingControl.setErrors(null);
            }
        }
    }

    actualizaPass() {
        this.authS.actualizaPasswordUsuario(this.usuarioObj).subscribe(response => {
            this.formGroupUsuario.reset();
            this.usuarioObj=new Usuario;
                swal.fire({
                    title: response.pCodRetorno === '00000' ? 'Éxito' : 'Error',
                    text: response.pMensaje,
                    buttonsStyling: false,
                    customClass:{
                        confirmButton: 'btn btn-success',
                        cancelButton: 'btn btn-danger',
                      },
                    confirmButtonText: 'Aceptar',
                    icon: response.pCodRetorno === '00000' ? 'success' : 'warning'
                }).then(responseMsg => {
                    if (response.pCodRetorno === '00000') 
                        this.router.navigate(['admin/ajustes']);
                  });
        });
    }

    cancelar() {
        this.router.navigate(['admin/ajustes']);
    }
    /*
        active(activa: string){
            if(activa != "********"){
                this.activa= true;
            }
              
    
          }
    
    */




}
